//设备
const state = {
	currentIndex: 0,
};
const getters = {
	currentIndex: (state) => {
		return state.currentIndex;
	},
};
const actions = {};
const mutations = {
	SET_CURRENTINDEX: (state, index) => {
		state.currentIndex = index;
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/deviceDetail.js